export const convertToValidDate = (
  dateString: string | null | undefined,
): Date | null => {
  return dateString ? new Date(dateString) : null;
};

export const isCurrentDateBetween = (
  fromDate: Date | null,
  toDate: Date | null,
): boolean => {
  if (!fromDate || !toDate) return true;

  const now = new Date();

  return fromDate < now && toDate > now;
};
